import { render, staticRenderFns } from "./DuplicateQuizModal.vue?vue&type=template&id=2371cc51&"
import script from "./DuplicateQuizModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateQuizModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateQuizModal.vue?vue&type=style&index=0&id=2371cc51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports